'use client' // Error components must be Client Component
import { Button } from '@/shared/ui/button'
import Image from 'next/image'
import { useEffect } from 'react'
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    <html>
      <body>
        <main className="relative flex h-screen flex-col items-center justify-center">
          <Image
            src="/images/404-page-background.png"
            width={362}
            height={520}
            alt=""
            className="absolute"
            priority
          />
          <div className="relative -top-5 flex">
            <Image
              src="/icons/error-500.svg"
              width={64}
              height={64}
              alt=""
              priority
            />
          </div>
          <h2 className="relative mb-[8px] text-body-01-semi">
            알 수 없는 오류가 발생했습니다.
          </h2>
          <p className={`relative text-caption-01-regular text-gray-5`}>
            문제 해결을 위해 노력하고 있습니다.
          </p>
          <p className={`relative pb-7 text-caption-01-regular text-gray-5`}>
            다시 시도하거나 새로고침 해주세요.
          </p>

          <Button className="relative w-[255px]" onClick={reset}>
            다시 시도하기
          </Button>
        </main>
      </body>
    </html>
  )
}
